export const numberOfWitness = {amountOfWaste: Math.floor(Math.random() * (15 - 12 + 1) + 12)};